export const validationMessages = {
  emailAddress: `Hmm. Can you double check your email address? There might be a typo in there somewhere.`,
  mobileNumber: `Ah, that didn’t work. Your mobile number must start with 07 and it should be 11 digits long using numbers only. We need this so you can access internet and telephone banking.`,
  homePhoneNumber: `Ah, that didn’t work. Your phone number needs to be 11 digits long using numbers only.`,
  workPhoneNumber: `Ah, that didn’t work. Your phone number needs to be 11 digits long using numbers only.`,
  preferredMethod: `Hmm, looks like we’re missing something. Can you choose one of the contact methods then try again?`
};
